"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInfo = void 0;
var React = require("react");
var react_1 = require("react");
var state_1 = require("../compare/state");
var Actions_1 = require("./Actions");
var ProductInfo = function () {
    var _a = (0, state_1.useStateValue)(), state = _a.state, dispatch = _a.dispatch;
    var products = state.products;
    var _b = (0, react_1.useState)(0), elementHeight = _b[0], setElementHeight = _b[1];
    var divElement = [];
    (0, react_1.useEffect)(function () {
        var height = 0;
        divElement.forEach(function (d) {
            if (d.clientHeight > height) {
                height = d.clientHeight;
            }
        });
        setElementHeight(height);
    }, []);
    var removeProductFromComparison = function (product) {
        var index = products.indexOf(product);
        products.splice(index, 1);
        if (products.length === 1) {
            window.location.href = products[0].productUrl;
        }
        else {
            (0, Actions_1.setProductsAction)(dispatch, products);
        }
    };
    var getColClass = function (numberOfProducts) {
        var maxColLength = 12;
        var colLength = maxColLength / numberOfProducts;
        return "col-xs-".concat(colLength);
    };
    function calculateElementHeight(element) {
        if (element) {
            divElement.push(element);
        }
    }
    var generateProductInfo = function (products) {
        var productInfo = products.map(function (product) {
            return React.createElement("div", { className: getColClass(products.length), key: product.arident },
                React.createElement("div", { className: "compare-product-content" },
                    React.createElement("div", { className: "product-info", ref: function (element) { return calculateElementHeight(element); }, style: { minHeight: elementHeight } },
                        React.createElement("div", { className: "image-header" },
                            React.createElement("i", { className: "glyphicon glyphicon-remove-circle close-button", onClick: removeProductFromComparison.bind(_this, product) }),
                            React.createElement("div", { className: "image" },
                                React.createElement("img", { src: product.imageUrl }))),
                        React.createElement("p", { className: "product-name" }, product.productName)),
                    React.createElement("div", { className: "button-section" },
                        React.createElement("a", { className: "btn btn-standard", href: product.productUrl }, "Vis produkt"))));
        });
        return productInfo;
    };
    return (React.createElement("div", { className: "row" }, generateProductInfo(products)));
};
exports.ProductInfo = ProductInfo;
